import React from 'react'; 
import logo from '../images/logo.png';
import '../styles/frontpage.css';

class ThankYou extends React.Component {
    constructor(props){
        super(props); 

        this.state = {
            formLogo: ""
        }
    }

    componentDidMount(){
        if (localStorage.getItem('formlogo')){
            this.setState({
                formLogo: localStorage.getItem('formlogo')
            });
        }

        if (this.props.redirect != ''){
            let url = this.props.redirect; 
            setTimeout(function(){
                window.location.href = url;
            }, 3000);
        }
    }

    render() {
        let formLogo; 

        if (this.state.formLogo.length > 0){
            formLogo = <img src={ this.state.formLogo } style={{width: "150px", height: "auto"}} className="img-fluid" alt="" />;
        }

        return(
            <div className="py-5">
                <div style={{margin: 'auto', width: "50%", padding: "10px"}}>
                    <h5 className="pt-3 pb-0 mb-0">Entry complete.</h5>
                    <p>Thank you.</p>
                </div>
                <div className="text-right" style={{position: "fixed", bottom: "0px", right: "0px"}}>
                    <small className="text-right text-black-50">Powered by</small><br />
                    <img src={ logo } style={{width: "100px", height: "auto"}} className="img-fluid" alt="Adapticts.com" />
                </div>
            </div>
        )
    }

}

export default ThankYou; 